import { useEffect, useState } from 'react';
import { subscriptionApi, type UsageStats, type SubscriptionResponse } from '../api/subscriptionApi';

export function useSubscription() {
  const [subscription, setSubscription] = useState<SubscriptionResponse | null>(null);
  const [usage, setUsage] = useState<UsageStats | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    loadSubscription();
  }, []);

  const loadSubscription = async () => {
    try {
      setIsLoading(true);
      const data = await subscriptionApi.getStatus();
      setSubscription(data);
      setUsage(data.usage);
      setError(null);
    } catch (err) {
      setError(err as Error);
      console.error('Failed to load subscription:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const canAddTrainee = usage?.canAddTrainee ?? false;
  const canAddTemplate = usage?.canAddTemplate ?? false;
  const hasAutoProlongation = subscription?.plan?.hasAutoProlongation ?? false;
  const maxTrainingSetDurationDays = subscription?.plan?.maxTrainingSetDurationDays ?? 30;

  return {
    subscription,
    usage,
    isLoading,
    error,
    canAddTrainee,
    canAddTemplate,
    hasAutoProlongation,
    maxTrainingSetDurationDays,
    refetch: loadSubscription,
  };
}
